import React, { useContext, useState } from 'react';
import ModalContext from '../../../context/ModalContext.js';
import AuthContext from '../../../context/AuthContext.js';
import { Button, CircularProgress } from '@mui/material';

const DeleteUserModal = ({ modalDetails, onDeleted }) => {
  const modalCtx = useContext(ModalContext);
  const authCtx = useContext(AuthContext);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleCancel = () => {
    modalCtx.closeModal();
  };

  const handleDelete = async () => {
    const userId = modalDetails?.user?.id;

    if (!userId) {
      console.error('User ID is missing');
      return;
    }

    setIsDeleting(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URI}/v3/user/${userId}/delete`,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authCtx.token}`
          }
        }
      );

      const data = await response.json();

      if (data.status === 'success') {
        modalCtx.closeModal();
        if (onDeleted) onDeleted();
      } else {
        console.error('Failed to delete user:', data.message || 'Unknown error');
        alert(data.message || 'Failed to delete user. Please try again.');
        setIsDeleting(false);
      }
    } catch (error) {
      console.error('Error deleting user:', error);
      alert('An error occurred while deleting the user. Please try again.');
      setIsDeleting(false);
    }
  };

  const userName = modalDetails?.user?.name || modalDetails?.user?.email || 'this user';

  return (
    <div className="modal-container">
      <div className="modal-header">
        <h1>Confirm Deletion</h1>
      </div>
      <div className="modal-body">
        <p style={{ textAlign: 'center', fontSize: '1rem', color: '#555', margin: 0 }}>
          Are you sure you want to permanently delete {userName}? This action cannot be undone.
        </p>
      </div>
      <div className="modal-footer">
        <Button className="cancel-btn" onClick={handleCancel} disabled={isDeleting}>
          CANCEL
        </Button>
        <Button onClick={handleDelete} variant="contained" disabled={isDeleting}>
          {isDeleting ? <CircularProgress size={22} style={{ color: '#fff' }} /> : 'DELETE'}
        </Button>
      </div>
    </div>
  );
};

export default DeleteUserModal;
